module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-10.ad1870fd.JPG";